<section id="portfolio">
    <div class="container" >
        <h2><strong>Projects</strong></h2>
        <span class="bar-title mb-5"></span>
        <div class="row">



          <div class="col-lg-4 col-sm-12"  data-aos="flip-up">
            <div class="card shadow-lg p-3  bg-white rounded">
                <div  class="card-header d-flex flex-column " style="height: 325px; width: 100%; "  >
                    <div id="weatherapp-img" class="img-wrap" style="height: 300px; width: 100%;  " [ngStyle]="{backgroundImage:'url(assets/images/weather_app_1.jpg)'}" >

                    </div>
                    <div id="portfolio-link" class="links mt-auto d-flex justify-content-center">
                        <a href="assets/images/weather_app_1.jpg" data-gall="weatherappGallery" class="venobox vbox-item" title="Portfolio"><i class="bx bx-zoom-in bx-md"></i></a>
                    </div>
                </div>

                <div class="card-body">
                    <h3 class="card-title">Weather App</h3>
                    <h5 class="card-title"><strong>Technologies:</strong>  </h5>
                    <p class="card-text">Angular <s>13,</s> 14, Html5, CSS, TypeScript</p>

                    <div class="d-flex flex-row justify-content-center">
                        <a href="https://github.com/mattriney/WeatherApp" target="_blank" type="button" class="btn btn-primary mr-3">Code Source</a>
                        <button (click)="detailOnClick('weatherapp')"  type="button" class="btn btn-primary">Project Detail</button>
                    </div>

                    <div *ngIf="weatherappIsShown" class="mt-3">
                        <p>Work in progress:
                          <br>
                          <br>
                          A full-stack weather app built in Angular. This project displays weather information obtained via the Open Weather Map API. It also allows a user to search for their own city in the search bar, retrieve, and display that information in the app.
                          <br>
                          <br>
                          Deployed to Firebase: <a href="https://weather-app-f6456.web.app/" target="_blank">Weather App</a>


                     </p>
                    </div>
                </div>

            </div>
        </div>

            <div class="col-lg-4 col-sm-12 " data-aos="flip-up">
                <div class="card shadow-lg p-3 mb-5 bg-white rounded">
                    <div  class="card-header d-flex flex-column " style="height: 300px;width: 100%; "  >
                        <div id="toDoApp-img" class="img-wrap" style="height: 300px;width: 100%;  " [ngStyle]="{backgroundImage:'url(assets/images/Todo_app.jpg)'}" >
                        </div>
                        <div id="toDoApp-link" class="links mt-auto d-flex justify-content-center">
                            <a href="assets/images/Todo_app.jpg" data-gall="toDoAppGallery" class="venobox vbox-item" title="Todo Application"><i class="bx bx-zoom-in bx-md"></i></a>
                        </div>
                    </div>

                    <div class="card-body">
                            <h3 class="card-title">Todo Application</h3>
                            <h5 class="card-title"><strong>Technologies:</strong>  </h5>
                            <p class="card-text">Angular 12, Html5, CSS,<br> TypeScript
                              </p>
                            <div class="d-flex flex-row justify-content-center">
                                <a href="https://github.com/mattriney/Todo-app" target="_blank" type="button" class="btn btn-primary mr-3">Code Source</a>
                                <button (click)="detailOnClick('toDoApp')" type="button" class="btn btn-primary">Project Detail</button>
                            </div>
                            <div *ngIf="toDoAppIsShown" class="mt-3">
                                <p>A simple single page todo app. <br><br>
                                  Deployed to Heroku:
                                  <a href="https://todo-app-mr.herokuapp.com/" target="_blank">Todo app</a>
                                </p>
                            </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-12"  data-aos="flip-up">
                <div class="card shadow-lg p-3 mb-5 bg-white rounded">

                    <div  class="card-header d-flex flex-column " style="height: 300px;width: 100%; "  >
                        <div  id="roster-img" class="img-wrap" style="height: 300px;width: 100%;  " [ngStyle]="{backgroundImage:'url(assets/images/roster_function.jpg)'}" >

                        </div>
                        <div id="roster-link" class="links mt-auto d-flex justify-content-center">
                            <a href="assets/images/roster_function.jpg" data-gall="StudentRosterGallery" class="venobox vbox-item" title="Student Roster"><i class="bx bx-zoom-in bx-md"></i></a>
                            <a href="assets/images/roster_function.jpg" data-gall="StudentRosterGallery" class="venobox vbox-item" title="Détail de la compagne"></a>


                        </div>
                    </div>
                    <div class="card-body">
                        <h3 class="card-title">Student Roster</h3>
                        <h5 class="card-title"><strong>Technologies:</strong>  </h5>
                        <p class="card-text">C++</p>
                        <br>

                        <div class="d-flex flex-row justify-content-center">
                            <a href="https://github.com/mattriney/Class-Roster" target="_blank" type="button" class="btn btn-primary mr-3">Code Source</a>
                            <button (click)="detailOnClick('studentRoster')"  type="button" class="btn btn-primary">Project Detail</button>
                        </div>
                        <div *ngIf="studentRosterIsShown" class="mt-3">
                            <p>A Student roster console application written in C++.</p>
                            <p>The program contains two classes (i.e., Student and Roster). It maintains a current roster of students within a given course. Student data for the program includes student ID, first name, last name, email address, age, an array of the number of days to complete each course, and degree program. It iterates through a list of five students and uses function calls to manipulate data. The entire student list is stored in one array and data is displayed to the console.<br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-12"  data-aos="flip-up">
                <div class="card shadow-lg p-3  bg-white rounded">
                    <div  class="card-header d-flex flex-column " style="height: 300px;width: 100%; "  >
                        <div id="portfolio-img" class="img-wrap" style="height: 300px;width: 100%;  " [ngStyle]="{backgroundImage:'url(assets/images/portfolio_1.jpg)'}" >

                        </div>
                        <div id="portfolio-link" class="links mt-auto d-flex justify-content-center">
                            <a href="assets/images/portfolio_1.jpg" data-gall="portfolioGallery" class="venobox vbox-item" title="Portfolio"><i class="bx bx-zoom-in bx-md"></i></a>
                            <a href="assets/images/portfolio_2.jpg" data-gall="portfolioGallery" class="venobox vbox-item" title="Trainers"></a>
                            <a href="assets/images/portfolio_3.jpg" data-gall="portfolioGallery" class="venobox vbox-item" title="Profile"></a>
                        </div>
                    </div>

                    <div class="card-body">
                        <h3 class="card-title">Portfolio</h3>
                        <h5 class="card-title"><strong>Technologies:</strong>  </h5>
                        <p class="card-text">Angular <s>11, 12, 13,</s>  14, Html5, CSS, TypeScript, BootStrap</p>

                        <div class="d-flex flex-row justify-content-center">
                            <a href="https://github.com/mattriney/portfolio-main" target="_blank" type="button" class="btn btn-primary mr-3">Code Source</a>
                            <button (click)="detailOnClick('portfolio')"  type="button" class="btn btn-primary">Project Detail</button>
                        </div>

                        <div *ngIf="portfolioIsShown" class="mt-3">
                            <p>This is my portfolio. I built it to showcase skills, projects, and interests, etc. I intend for it to be under a constant state of change and growth and to grow and change as my skills do.
                              <br>
                              <br>
                              Deployed to Heroku: <a href="https://matthew-riney.herokuapp.com/" target="_blank">Portfolio</a>
                              <br>
                              Deployed to Firebase: <a href="https://matthew-riney.firebaseapp.com/" target="_blank">Portfolio</a>


                         </p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</section>
